import { z } from 'zod'

/**
 * ISO 3166-1 Country
 * @example { code: "DE", name: "Germany" }
 */
export const Country = z.object({
  code: z.string().length(2),
  name: z.string().min(1)
})
export type Country = z.infer<typeof Country>

/**
 * ISO 3166-2 Subdivision (state/province/region)
 * @example { code: "DE-BY", name: "Bayern" }
 */
export const Subdivision = z.object({
  code: z.string().min(2),
  name: z.string().min(1)
})
export type Subdivision = z.infer<typeof Subdivision>

/**
 * API Response: List of countries
 */
export const CountriesResponse = z.object({
  countries: z.array(Country)
})
export type CountriesResponse = z.infer<typeof CountriesResponse>

/**
 * API Response: List of subdivisions for a country
 */
export const SubdivisionsResponse = z.object({
  subdivisions: z.array(Subdivision)
})
export type SubdivisionsResponse = z.infer<typeof SubdivisionsResponse>

/**
 * API Response: State suggestion based on postcode
 */
export const StateSuggestion = z.object({
  code: z.string().min(2),
  name: z.string().min(1),
  confidence: z.enum(['high', 'medium', 'low'])
})
export type StateSuggestion = z.infer<typeof StateSuggestion>

/**
 * Country with flag emoji (merged from API + country-codes-list)
 */
export interface CountryWithFlag extends Country {
  flag: string
  callingCode: string
}
